var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGeid12(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 640,
    height: 360,
    viewBox: "0 0 640 360",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1511_20899)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 360,
    fill: "#FFC900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4779 115.619C88.3637 113.891 100.378 110.897 108.509 105.961C120.693 98.5704 125.473 86.9234 126.579 78.3822C131.01 44.2515 87.1225 41.5872 34.8521 44.596C-7.08646 47.0079 -31.2993 43.5623 -49.3692 50.8029C-65.2913 57.1797 -69.4318 69.3994 -70.1688 81.4832C-70.77 91.3444 -65.9749 106.418 -54.1449 109.407C-34.5623 114.357 4.25391 117.681 34.5127 117.681C42.7307 117.681 50.9293 117.492 58.8128 117.021C59.3946 140.636 66.9338 170.899 89.0473 181.517C89.3334 181.653 89.6 181.284 89.3819 181.051C68.7714 159.009 73.5325 126.81 74.4779 115.619Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7733 221.032L16.4079 211.054C16.2673 211.01 16.2964 210.811 16.437 210.802L54.7441 209.385C55.3356 206.905 55.7768 204.367 56.0726 201.78L77.6527 195.796C80.1399 195.054 81.4102 192.424 81.4102 190.05C81.4102 190.041 81.4102 190.031 81.4102 190.021C81.2599 187.318 79.3254 185.105 76.3485 185.071L55.7332 184.571C51.0399 153.945 24.849 130.5 -6.75766 130.5C-41.6854 130.5 -70 159.128 -70 194.442C-70 229.757 -41.6854 258.385 -6.75766 258.385C18.7836 258.38 40.7905 243.074 50.7733 221.032Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8767 189.585C21.8784 189.585 24.3117 187.125 24.3117 184.091C24.3117 181.057 21.8784 178.598 18.8767 178.598C15.875 178.598 13.4417 181.057 13.4417 184.091C13.4417 187.125 15.875 189.585 18.8767 189.585Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.339 140.44C119.873 103.301 152.377 75.3672 191.339 75.3672C235.876 75.3672 271.977 111.871 271.977 156.897C271.977 201.922 235.876 238.426 191.339 238.426C160.862 238.426 134.336 221.334 120.625 196.113C123.272 196.438 126.07 196.453 128.94 196.128C140.334 194.827 149.405 188.47 151.907 180.826H114.23C112.877 176.367 111.893 171.737 111.316 166.986C98.6714 170.436 86.7783 161.837 86.7783 154.524C86.7735 146.026 95.4812 141.309 112.339 140.44C116.863 140.207 123.437 140.198 127.306 140.212Z",
    fill: "#FF90E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.339 140.44C119.873 103.301 152.377 75.3672 191.339 75.3672C235.876 75.3672 271.977 111.871 271.977 156.897C271.977 201.922 235.876 238.426 191.339 238.426C160.862 238.426 134.336 221.334 120.625 196.113C123.272 196.438 126.07 196.453 128.94 196.128C140.334 194.827 149.405 188.47 151.907 180.826H114.23C112.877 176.367 111.893 171.737 111.316 166.986C98.6714 170.436 86.7783 161.837 86.7783 154.524C86.7735 146.026 95.4812 141.309 112.339 140.44ZM112.339 140.44C116.863 140.207 123.437 140.198 127.306 140.212",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.838 153.839C170.84 153.839 173.274 151.379 173.274 148.345C173.274 145.311 170.84 142.852 167.838 142.852C164.837 142.852 162.403 145.311 162.403 148.345C162.403 151.379 164.837 153.839 167.838 153.839Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.5163 252.412C73.0234 253.232 57.1498 254.945 44.6409 258.235C25.4316 263.287 16.5 278.5 16.5 296C16.5 313.5 21.9653 326.256 44.6409 336.657C53.6977 340.811 74.2597 341.092 90.5163 341C107.869 340.903 134.518 342.351 158 341C233.5 336.657 245.5 317.5 245.5 296C246.504 288.279 239.5 273.5 226.5 265.5C213.5 257.5 204.25 257.459 184.318 255.721C163.165 253.872 141.967 251.757 122.802 251.757C115.544 251.757 108.378 251.829 101.396 252.014C97.1101 231.398 82.6862 216.684 63.7436 220.28C90.0751 230.855 90.5163 252.412 90.5163 252.412Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.497 267.989C368.576 270.498 362.758 275.72 350.783 275.744C341.595 290.143 325.59 299.674 307.385 299.674C278.881 299.674 255.778 276.312 255.778 247.495C255.778 218.683 278.881 195.316 307.385 195.316C335.888 195.316 358.991 218.678 358.991 247.495C358.991 249.582 358.87 251.644 358.632 253.668C371.572 257.604 370.772 264.51 369.497 267.989Z",
    fill: "#90A8ED",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.144 272.703C340.087 274.916 345.939 275.756 350.783 275.746Z",
    fill: "#90A8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.144 272.703C340.087 274.916 345.939 275.756 350.783 275.746",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.637 253.67C354.39 252.379 348.654 251.404 340.969 250.977Z",
    fill: "#90A8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.637 253.67C354.39 252.379 348.654 251.404 340.969 250.977",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.125 283.436C333.876 289.866 311.423 287.57 309.096 278.219L333.125 283.436Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.218 260.003C319.011 260.003 321.275 257.713 321.275 254.888C321.275 252.064 319.011 249.773 316.218 249.773C313.426 249.773 311.161 252.064 311.161 254.888C311.161 257.713 313.426 260.003 316.218 260.003Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.639 124.949C358.938 120.703 373.914 102.893 378.923 81.9375C384.382 59.1044 365.832 38.5376 319.394 39.581C286.604 40.3187 262.295 58.8909 262.295 82.714C262.295 106.275 284.641 126.585 318.284 125.876C321.067 174.9 338.734 184.737 360.276 171.896C341.367 171.562 334.361 164.67 331.467 149.243C329.663 137.397 329.639 124.949 329.639 124.949Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.174 454.154C381.195 448.208 402.163 423.273 409.176 393.934C416.819 361.966 390.848 333.171 325.831 334.631C279.923 335.664 245.887 361.667 245.887 395.021C245.887 428.008 277.174 456.443 324.276 455.451C328.173 524.089 352.909 537.862 383.068 519.884C356.595 519.415 346.786 509.767 342.733 488.167C340.208 471.581 340.174 454.154 340.174 454.154Z",
    fill: "#FF7051",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.742 129.176C380.188 128.2 371.897 127.099 367.912 133.01C364.949 137.397 365.686 146.234 379.873 147.641C380.333 152.189 381.23 156.605 382.515 160.851L417.07 161.793C417.899 161.817 418.238 162.884 417.569 163.389L393.036 181.927C405.584 199.058 425.709 210.176 448.4 210.23C485.892 210.317 516.437 180.476 517.577 142.589C518.774 102.756 486.949 70.135 447.711 70.6106C413.773 71.0231 386.055 95.8507 380.518 128.414",
    fill: "#FFC900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.742 129.176C380.188 128.2 371.897 127.099 367.912 133.01C364.949 137.397 365.686 146.234 379.873 147.641C380.333 152.189 381.23 156.605 382.515 160.851L417.07 161.793C417.899 161.817 418.238 162.884 417.569 163.389L393.036 181.927C405.584 199.058 425.709 210.176 448.4 210.23C485.892 210.317 516.437 180.476 517.577 142.589C518.774 102.756 486.949 70.135 447.711 70.6106C413.773 71.0231 386.055 95.8507 380.518 128.414",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.813 140.717C419.654 140.717 421.957 138.388 421.957 135.515C421.957 132.642 419.654 130.312 416.813 130.312C413.972 130.312 411.669 132.642 411.669 135.515C411.669 138.388 413.972 140.717 416.813 140.717Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.57 295.723C434.378 302.662 453.544 306.841 478.125 306.501C543.317 305.593 560.761 292.738 567.379 254.075C569.411 242.195 559.443 229.3 537.984 222.778C522.75 218.148 498.828 219.643 478.125 219.992C430.742 220.793 392.144 227.107 393.788 260.306C394.34 271.502 400.275 282.12 411.649 290.346C402.578 298.702 368.969 302.279 368.969 302.279C368.969 302.279 398.151 313.577 420.57 295.723Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.656 196.637C602.944 200.835 601.567 205.207 600.564 209.721L617.101 220.713L598.634 225.425C598.615 226.153 598.605 226.886 598.605 227.623C598.605 262.458 620.282 292.177 650.74 303.742V151.5C635.496 157.29 622.449 167.626 613.223 180.875C599.798 175.09 596.889 175.09 594.469 175.862C592.709 176.42 588.205 179.933 589.858 185.728C591.517 191.522 604.656 196.637 604.656 196.637Z",
    fill: "#98282A",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.968 203.457C631.817 203.457 634.127 201.122 634.127 198.24C634.127 195.359 631.817 193.023 628.968 193.023C626.119 193.023 623.81 195.359 623.81 198.24C623.81 201.122 626.119 203.457 628.968 203.457Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.552 142.011C578.22 142.219 579.883 142.316 581.532 142.302C612.954 141.991 634.782 120.071 633.54 96.2717C633.191 89.6329 631.412 83.7754 629.172 78.7817C622.132 63.097 609.066 53.7697 581.537 50.5813C567.913 49.0041 554.017 47.7229 543.651 57.1861C533.756 66.2175 527.661 79.1408 528.878 95.141C530.28 113.577 547.758 132.877 567.03 139.715C557.615 166.838 553.799 189.846 574.274 200.683C558.725 178.68 576.552 142.011 576.552 142.011Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 589.256,
    cy: 393.52,
    r: 86,
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 468.303,
    cy: -30.7649,
    r: 73.4382,
    fill: "#90A8ED",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202,
    cy: -69.5,
    r: 96,
    fill: "#98282A",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: -63.457,
    r: 90,
    fill: "#FF7051",
    stroke: "black",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1511_20899"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 360,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeid12);
export default __webpack_public_path__ + "static/media/geid12.a49d911070525d4862cf3160066e10a2.svg";
export { ForwardRef as ReactComponent };